import { Injectable } from '@angular/core';
import { ApiConnectionsModel, ApiConnectionsRepository } from '@database/central';
import { TranslateService } from '@ngx-translate/core';
import { Dictionary, EncryptionService, ToastDuration, ToastService } from '@shared';
import { Observable, map, shareReplay } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ApiKeyProviderService {
	private apiKeyDictionary$: Dictionary<Observable<string>> = {};

	public constructor(
		private apiConnectionsRepository: ApiConnectionsRepository,
		private encryptionService: EncryptionService,
		private toastService: ToastService,
		private translate: TranslateService
	) {}

	public get$(connectionId: string): Observable<string> {
		if (this.apiKeyDictionary$[connectionId]) {
			return this.apiKeyDictionary$[connectionId];
		}

		this.apiKeyDictionary$[connectionId] = this.apiConnectionsRepository.getConnectionDetails$(connectionId).pipe(
			map((apiConnectionsModel: ApiConnectionsModel) => this.decryptApiKey(apiConnectionsModel?.apiKey)),
			shareReplay(1)
		);

		return this.apiKeyDictionary$[connectionId];
	}

	private decryptApiKey(apiKey: string): string {
		try {
			return apiKey ? this.encryptionService.decrypt(apiKey) : apiKey;
		} catch (error) {
			this.toastService.presentError(
				this.translate.instant('connectionsModal.newConnectionOptions.apiKeyDecryptionFailed'),
				ToastDuration.Slow
			);
			return null;
		}
	}
}
